'use strict';

import NS from 'src/ns';
import $ from 'jquery';
import assign from 'lodash/assign';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

const $window = $(window);

class IndexPage {
  constructor(setting) {
    this.$header = $(setting.header);
    this.$showTrigger = $(setting.showTrigger);
    this.showModifier = '-shown';
    this.showTriggerPosition = null;
    this.ns = '.stl-IndexPage';
  }

  init() {
    this.setTriggerPosition();

    if (this.showTriggerPosition !== null) {
      this.addEvent();
    }
  }

  setTriggerPosition() {
    try {
      this.showTriggerPosition = this.$showTrigger.offset().top - this.$header.outerHeight() - 50;
    } catch (e) {}
  }

  addEvent() {
    const ns = this.ns;

    $window
      .on('resize' + ns, debounce(this.onResize.bind(this), 300))
      .on('scroll' + ns, throttle(this.onScroll.bind(this), 100));
  }

  onResize() {
    this.setTriggerPosition();
  }

  onScroll() {
    const showModifier = this.showModifier;

    if ($window.scrollTop() > this.showTriggerPosition) {
      this.$header.addClass(showModifier);
    } else {
      this.$header.removeClass(showModifier);
    }
  }
}

assign(IndexPage, {
  create: function(setting) {
    new IndexPage(setting).init();
  }
});


export default NS.IndexPage = IndexPage;


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/block/indexPage.js